<template>
    <v-container id="my-account-content-wrapper">
        <client-only>
            <!-- v-if="$store.state.auth && !$store.state.auth.loggedIn" -->
            <v-row
                v-if="!isLoggedIn"
                column
                justify-center
                align-center
                no-gutters
            >
                <v-col cols="12">
                    <FormLogin />
                </v-col>
            </v-row>
            <v-row
                v-else
                column
                justify-center
                align-center
                class="elasticbase-container"
            >
                <v-col cols="12" md="3">
                    <div v-if="isDashboard || !$vuetify.breakpoint.smAndDown">
                        <client-only>
                            <vue-sticky-sidebar
                                container-selector=".elasticbase-container"
                                :bottom-spacing="100"
                            >
                                <div class="text-center">
                                    <div>
                                        <TranslatableStringComponent
                                            :tstring="{
                                                string: `${welcomeMessage.message}`,
                                            }"
                                        />
                                    </div>
                                    <h2>{{ welcomeMessage.name }}</h2>
                                    <div
                                        v-if="
                                            webUser &&
                                            webUser.WebUserPrimaryCustomerId
                                        "
                                    >
                                        <TranslatableStringComponent
                                            :tstring="{ string: 'customerID' }"
                                        />:
                                        {{ webUser.WebUserPrimaryCustomerId }}
                                    </div>
                                    <v-btn
                                        v-else
                                        color="primary"
                                        small
                                        light
                                        class="my-1"
                                        @click="showModal = true"
                                        ><TranslatableStringComponent
                                            :tstring="{ string: 'connectCustomerAccount' }"
                                    /><fa :icon="['fal', 'link']" class="fa-sm ml-1" style="color:white"
                        /></v-btn>
                                    <div>
                                        {{ webUser && webUser.email }}
                                    </div>
                                    <!-- <div>
                            <pre>{{ $store.state.auth.currentUser }}</pre>
                        </div> -->
                                </div>
                                <MenuMyAccount
                                    id="menuMyAccount"
                                    class="flex-column"
                                    :menu="menuMyAccount"
                                />
                            </vue-sticky-sidebar>
                        </client-only>
                    </div>
                </v-col>
                <v-col cols="12" md="9">
                    <div
                        v-if="!isDashboard || !$vuetify.breakpoint.smAndDown"
                        class="d-flex flex-column"
                    >
                        <h1>
                            <span v-if="page.title && page.title[$i18n.locale]">
                                {{ page.title[$i18n.locale] }}
                            </span>
                            <TranslatableStringComponent
                                v-else
                                :tstring="{ string: 'noTitleFound' }"
                            />
                        </h1>
                        <Content
                            v-if="page && page._id && page.contentSections"
                            :page="page"
                        />
                        <OrderHistoryErp v-if="isOrderHistory" />
                        <v-btn
                            v-if="isAddresses"
                            color="primary"
                            right
                            :disabled="
                                !(
                                    selectedShippingAddressID ||
                                    selectedBillingAddressID
                                )
                            "
                            class="mt-8 align-self-end"
                            @click="dialog = true"
                            ><TranslatableStringComponent
                                :tstring="{
                                    string: 'setSelectedCardsAsDefault',
                                }"
                        /></v-btn>
                        <ContactCards v-if="isAddresses" />
                        <v-btn
                            v-if="isAddresses"
                            color="primary"
                            right
                            :disabled="
                                !(
                                    selectedShippingAddressID ||
                                    selectedBillingAddressID
                                )
                            "
                            @click="dialog = true"
                            ><TranslatableStringComponent
                                :tstring="{
                                    string: 'setSelectedCardsAsDefault',
                                }"
                        /></v-btn>
                        <CardCustomerDetails v-if="isCustomerdetails" />
                        <ElasticProductResults v-if="isFavoriteProducts" />
                        <FormVerifyEmail v-if="isResetPassword" />
                        <SavedCarts v-if="isSavedCarts" />
                        <PageUnderConstruction v-if="isEditProfile" />
                        <FormContact v-if="isSupportPage" />
                        <PageUnderConstruction v-if="isC3News" />
                        <DevOutput class="mt-8">
                            <h2>DEBUG: webUser</h2>
                            <pre>{{ webUser }}</pre>
                            <h2>DEBUG: currentUser</h2>
                            <pre>{{ currentUser }}</pre>
                            -
                        </DevOutput>
                        <v-dialog v-model="dialog" width="500" persistent>
                            <v-card>
                                <v-progress-linear
                                    v-if="loader"
                                    indeterminate
                                    color="#0063a6"
                                ></v-progress-linear>
                                <v-card-title
                                    class="headline grey lighten-2"
                                    primary-title
                                >
                                    <TranslatableStringComponent
                                        :tstring="{
                                            string: 'setSelectedCardsAsDefault',
                                        }"
                                    />
                                    ?
                                </v-card-title>
                                <v-card-text>
                                    <p>
                                        <TranslatableStringComponent
                                            :tstring="{
                                                string:
                                                    'areYouSureYouWantToSetTheCardsAsDefault',
                                            }"
                                        />
                                    </p>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        color="primary"
                                        text
                                        @click="addDefaultAddress()"
                                    >
                                        <TranslatableStringComponent
                                            :tstring="{ string: 'yes' }"
                                        />
                                    </v-btn>
                                    <v-btn
                                        color="error"
                                        text
                                        @click="dialog = false"
                                    >
                                        <TranslatableStringComponent
                                            :tstring="{ string: 'no' }"
                                        />
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </div>
                </v-col>
            </v-row>
        </client-only>
        <ConnectCustomerDialog
            :showModal="showModal"
            :isAccountPage="true"
            stepperValue="2"
            @handlePostCustomerConnect="handlePostCustomerConnect()"
            @handleDialog="showModal = false"
        />
    </v-container>
</template>
<script>
import { mapState } from 'vuex'
import getDollarString from '~/mixins/getDollarString'
import isMyAccountRoutes from '~/mixins/isMyAccountRoutes'
import ContactCards from '~/components/ContactCards.vue'
import Content from '~/components/Content.vue'
import DevOutput from '~/components/DevOutput.vue'
import FormLogin from '~/components/forms/FormLogin.vue'
import FormVerifyEmail from '~/components/forms/FormVerifyEmail'
import MenuMyAccount from '~/components/menus/MenuMyAccount.vue'
import OrderHistoryErp from '~/components/OrderHistoryErp.vue'
import PageUnderConstruction from '~/components/PageUnderConstruction.vue'
import handleSnackbar from '~/mixins/handleSnackbar'
import handleAuth from '~/mixins/handleAuth'
import ElasticProductResults from '~/components/ElasticProductResults.vue'
import FormContact from '~/components/forms/FormContact.vue'
import CardCustomerDetails from '~/components/cards/CardCustomerDetails.vue'
import SavedCarts from '~/components/SavedCarts.vue'
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue'
import ConnectCustomerDialog from '~/components/ConnectCustomerDialog.vue'

export default {
    name: 'MyAccount',
    components: {
        ContactCards,
        Content,
        DevOutput,
        FormLogin,
        FormVerifyEmail,
        MenuMyAccount,
        PageUnderConstruction,
        ElasticProductResults,
        FormContact,
        OrderHistoryErp,
        CardCustomerDetails,
        SavedCarts,
        TranslatableStringComponent,
        ConnectCustomerDialog,
    },
    mixins: [handleSnackbar, handleAuth, isMyAccountRoutes, getDollarString],
    props: {
        data: {
            type: Object,
            default: null,
        },
        page: {
            type: Object,
            default: null,
        },
        show: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            dialog: false,
            loader: false,
            showModal: false,
        }
    },
    computed: {
        ...mapState('auth', ['webUser']),
        ...mapState(['common']),
        ...mapState('checkout', [
            'selectedBillingAddressID',
            'selectedShippingAddressID',
        ]),
        welcomeMessage() {
            if (
                this.$store.state.auth &&
                this.$store.state.auth.currentUserDetails &&
                this.$store.state.auth.currentUserDetails.full_name
            ) {
                return {
                    name: this.$store.state.auth.currentUserDetails.full_name, // this.auth.currentUser.user_metadata.full_name,
                    message: 'welcomeToC3Controls',
                }
            } else if (
                this.$store.state.auth &&
                this.$store.state.auth.currentUser &&
                this.$store.state.auth.currentUser.user_metadata &&
                this.$store.state.auth.currentUser.user_metadata.full_name
            ) {
                return {
                    name: this.$store.state.auth.currentUser.user_metadata
                        .full_name, // this.auth.currentUser.user_metadata.full_name,
                    message: 'welcomeToC3Controls',
                }
            } else {
                return {
                    name: '',
                    message: 'welcomeToC3Controls',
                }
            }
        },
        menuMyAccount() {
            return this.common.myAccount
        },
    },
    methods: {
        async addDefaultAddress() {
            this.loader = true
            const payload = {
                email: this.webUser.email,
                WebUserBillingContactId: this.selectedBillingAddressID,
                WebUserShippingContactId: this.selectedShippingAddressID,
            }
            const res = await this.$axios.post(
                'erp-webuser?method=update',
                payload
            )

            this.dialog = false
            this.loader = false
            if (res?.response?.errors.length > 0) {
                alert(this.localize('contactCreateEditErrorMessage'))
            }
        },
        handlePostCustomerConnect() {
            this.showModal = false
            this.hitSnackbar(
                { string:'youAreNowConnectedToYourCustomerAccount'},
                null
            )
        },
    },
}
</script>
